export const generatePlanCode = (packageName, planName, price) => {
    return `${packageName}_${planName}_${price}`
        .toUpperCase()
        .replace(/\s+/g, "_");
};
